import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  customButtonSecondaryRoot: { fontSize: '12px', lineHeight: '16px' },
  substitutionButtonIcon: { marginRight: '.5rem' },
  root: {
    paddingTop: '1rem',
    position: 'sticky',
    bottom: 0,
    display: 'grid',
    gap: '0.75rem',
    gridTemplateColumns: 'auto',
    backgroundColor: `${neutral.white}E8`,
  },
  tooltip: {
    fontSize: '0.75rem',
    backgroundColor: neutral.black,
    padding: '0.5rem',
    fontWeight: 700,
    width: '12.5rem',
  },
  cookingPrimaryBtn: {
    padding: '0.75rem 1rem',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    borderRadius: '0.5rem',
    color: neutral.white,
    backgroundColor: neutral[90],
    border: `1px solid ${neutral[100]}`,
    '&:hover': {
      color: neutral['20'],
      backgroundColor: neutral[100],
    },
  },
  cancelBtnToMP: {
    padding: '0.75rem 1rem',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[80],
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[90]}`,
    '&:hover': {
      color: neutral[100],
      borderColor: neutral[100],
      backgroundColor: neutral[10],
    },
  },
});
